<template>
    <Modal ref="Modal" :title="$t('groupProductModal.modalTitle')" size="lg">
        <div class="modal-body">
            <Alert type="info" class="mb-4">
                <span>{{ $t('groupProductModal.groupProductsInfoFirst') }}<b>{{` "${$t('labels.group_id')}"`}}</b>.</span><br>
                {{ $t('groupProductModal.groupProductsInfoSecond') }}
            </Alert>
            <div class="row mb-3">
                <div class="col-lg-6">
                    <InputGroup>
                        <Radio :model-value="selectedGrouping === 'manual'" @click="selectedGrouping = 'manual'"/>
                        <template #append>{{ $t('groupProductModal.manualGroupId') }}</template>
                    </InputGroup>
                </div>
                <div class="col-lg-6">
                    <InputGroup>
                        <Radio :model-value="selectedGrouping === 'available'" @click="selectedGrouping = 'available'"/>
                        <template #append>{{ $t('groupProductModal.selectAvailableGroupId') }}</template>
                    </InputGroup>
                </div>
            </div>
            <FormGroup :label="$t('labels.group_id')">
                <slot v-if="selectedGrouping === 'manual'">
                    <InputGroup>
                        <Input :placeholder="placeholder" v-model="groupKey"/>
                        <template #append>
                            <Button color="light" @click="groupKey = placeholder">
                                {{ $t('buttons.generate') }}
                            </Button>
                        </template>
                    </InputGroup>
                </slot>
                <slot v-else>
                    <Select
                        :options="availableGroupIds"
                        v-model="groupKey"
                        @update:model-value="(value) => groupKey = value.key"
                        :selected-value="groupKey"
                        option-key="key"
                        option-value="value"
                    />
                </slot>
            </FormGroup>
        </div>
        <div class="modal-footer d-flex justify-content-end">
            <Button size="sm" color="light" class="mr-2" @click="() => $refs.Modal.hide()">
                {{ $t('groupProductModal.cancelButton') }}
            </Button>
            <Button size="sm" color="indigo" @click="groupProducts">
                {{ $t('groupProductModal.groupButton') }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import InputGroup from "../../../../../components/new/form/InputGroup.vue";
import Radio from "../../../../../components/new/form//radio/Radio.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import Select from "../../../../../components/new/form/select/AppSelect.vue";
import Alert from "../../../../../components/AlertComponent.vue";

import { httpClient } from "../../../../../services/HttpClient.ts";
import { chunk } from "../../../../../utils";

export default {
    name: 'GroupProductsModal',
    components: {
        Modal, Radio, FormGroup, InputGroup, Input, Button, Select, Alert
    },
    emits: ['products:grouped'],
    data() {
        return {
            products: [],
            selectedGrouping: "manual",
            placeholder: '',
            groupKey: null,
            availableGroupIds: [],
        }
    },
    methods: {
        async show(productUuids) {
            this.groupKey = null;
            this.availableGroupIds = [];
            this.selectedGrouping = "manual";
            this.products = [];
            this.placeholder = this.generateGroupId();

            await httpClient.get('/catalog/product-items', {
                uuids: productUuids,
                limit: 0
            }).then(response => {
                this.products = response.data.data;
                response.data.data.forEach(product => {
                    if (product.group_key) {
                        if (!this.availableGroupIds.some(group => group.key === product.group_key)) {
                            this.availableGroupIds.push({
                                key: product.group_key,
                                value: product.group_key
                            });
                        }
                    }
                });
            });

            this.$refs.Modal.show();
        },
        generateGroupId() {
            return Math.floor(100000 + Math.random() * 900000);
        },
        async groupProducts() {
            let chunkedProducts = chunk(this.products.filter(product => product.group_id !== this.groupKey), 10);

            await Promise.all(chunkedProducts.map(async (chunk) => {
                await httpClient.post('/batch', {
                    data: chunk.map(product => ({
                        method: 'PATCH',
                        path: `/catalog/product-items/${product.uuid}`,
                        body: {
                            group_key: this.groupKey.toString(),
                        }
                    }))
                })
            }));

            this.$refs.Modal.hide();
            this.$emit('products:grouped');
        }
    }
}
</script>